import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import {
    postCertificate,
    UploadTaxExemptionFormModel,
    UploadTaxExemptionFormResult,
} from "@SupplyLand/Services/TaxCertificateService";

type UploadCertificateParameter = {
    onError?: (error: string) => void;
} & { taxForm: UploadTaxExemptionFormModel } & HasOnSuccess<UploadTaxExemptionFormResult>;

type HandlerType = ApiHandler<UploadCertificateParameter, UploadTaxExemptionFormResult>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await postCertificate(props.apiParameter.taxForm);
    if (result === null || result === undefined) {
        return false;
    }
    props.apiResult = result;
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const sendTaxCertificate = createHandlerChainRunner(chain, "SendTaxCertificate");
export default sendTaxCertificate;
